var _ellipse, _ellipse2, _ellipse3, _path, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path2, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _path3, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _path4, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _path5, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _path6, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _path7, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _path8, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _path9, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _path10, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _path11, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _path12, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _path13, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _path14, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _path15, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _path16, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _path17, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _path18, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _path19, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _path20, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _path21, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _path22, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _path23, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _path24, _ellipse142, _ellipse143, _ellipse144, _ellipse145, _ellipse146, _ellipse147, _path25, _ellipse148, _ellipse149, _ellipse150, _ellipse151, _ellipse152, _ellipse153, _path26, _ellipse154, _ellipse155, _ellipse156, _ellipse157, _ellipse158, _ellipse159, _path27, _ellipse160, _ellipse161, _ellipse162, _ellipse163, _ellipse164, _ellipse165, _path28, _ellipse166, _ellipse167, _ellipse168, _ellipse169, _ellipse170, _ellipse171, _path29, _ellipse172, _ellipse173, _ellipse174, _ellipse175, _ellipse176, _ellipse177, _path30, _ellipse178, _ellipse179, _ellipse180, _ellipse181, _ellipse182, _ellipse183, _path31, _ellipse184, _ellipse185, _ellipse186, _ellipse187, _ellipse188, _ellipse189, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _ellipse190, _ellipse191, _ellipse192, _ellipse193, _ellipse194, _ellipse195, _path69, _ellipse196, _ellipse197, _ellipse198, _ellipse199, _ellipse200, _ellipse201, _path70, _ellipse202, _ellipse203, _ellipse204, _ellipse205, _ellipse206, _ellipse207, _path71, _ellipse208, _ellipse209, _ellipse210, _ellipse211, _ellipse212, _ellipse213, _path72, _ellipse214, _ellipse215, _ellipse216, _circle, _g, _path73, _path74, _path75, _g2, _path76, _path77, _path78, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlitecoinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 175,
    cy: 86.854,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 175,
    cy: 84.9429,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.64,
    cx: 175,
    cy: 67.0738,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M175 53.1987V18.5098",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.79,
    cx: 175,
    cy: 11.5728,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.51,
    cx: 175,
    cy: 2.63823,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.37,
    cx: 175,
    cy: 0.726122,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.28,
    cx: 175,
    cy: 349.265,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.84,
    cx: 175,
    cy: 344.008,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 175,
    cy: 336.806,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M175 323.844V278.476",
    stroke: "#FFB801",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.74,
    cx: 175,
    cy: 271.992,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.82,
    cx: 175,
    cy: 268.394,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.52,
    cx: 175,
    cy: 263.135,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.84,
    cx: 159.696,
    cy: 88.1939,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.99,
    cx: 158.7,
    cy: 82.5406,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.95,
    cx: 155.823,
    cy: 66.23,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M153.66 53.9657L148.255 23.3105",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.83,
    cx: 147.174,
    cy: 17.1822,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 145.734,
    cy: 9.02495,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.76,
    cx: 144.739,
    cy: 3.37163,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.51,
    cx: 205.263,
    cy: 346.618,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.48,
    cx: 203.732,
    cy: 337.934,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 203.072,
    cy: 334.204,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M200.893 321.83L193.257 278.532",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.51,
    cx: 192.167,
    cy: 272.347,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.34,
    cx: 191.837,
    cy: 270.481,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.71,
    cx: 190.306,
    cy: 261.799,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.32,
    cx: 144.855,
    cy: 92.1705,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.71,
    cx: 142.936,
    cy: 86.8951,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.53,
    cx: 137.285,
    cy: 71.3707,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M132.998 59.6L122.283 30.1602",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.17,
    cx: 120.141,
    cy: 24.2691,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.46,
    cx: 117.315,
    cy: 16.5103,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.64,
    cx: 115.396,
    cy: 11.2349,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.73,
    cx: 234.606,
    cy: 338.754,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.62,
    cx: 232.078,
    cy: 331.813,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.17,
    cx: 229.278,
    cy: 324.121,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M224.227 310.243L211.598 275.55",
    stroke: "#FFB801",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 209.072,
    cy: 268.611,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.61,
    cx: 207.673,
    cy: 264.762,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.32,
    cx: 205.147,
    cy: 257.821,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.84,
    cx: 130.93,
    cy: 98.6646,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.69,
    cx: 127.86,
    cy: 93.3443,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 120.192,
    cy: 80.066,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M113.835 69.0554L97.9454 41.5371",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.35,
    cx: 94.769,
    cy: 36.0318,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 90.9326,
    cy: 29.3912,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 87.8631,
    cy: 24.0757,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.57,
    cx: 262.137,
    cy: 325.917,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 259.102,
    cy: 320.662,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 250.477,
    cy: 305.718,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M242.458 291.832L230.428 270.999",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.86,
    cx: 226.418,
    cy: 264.053,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.56,
    cx: 222.105,
    cy: 256.584,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.66,
    cx: 219.07,
    cy: 251.33,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.88,
    cx: 118.345,
    cy: 107.474,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.97,
    cx: 115.684,
    cy: 104.304,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.28,
    cx: 103.118,
    cy: 89.3316,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M95.3197 80.0383L75.822 56.8047",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.83,
    cx: 71.9228,
    cy: 52.1548,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.57,
    cx: 65.6397,
    cy: 44.6695,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.26,
    cx: 62.9791,
    cy: 41.4976,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.79,
    cx: 287.023,
    cy: 308.492,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.31,
    cx: 286.071,
    cy: 307.359,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.73,
    cx: 280.127,
    cy: 300.277,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M271.218 289.658L240.034 252.501",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.57,
    cx: 235.58,
    cy: 247.191,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.84,
    cx: 232.608,
    cy: 243.648,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.42,
    cx: 231.658,
    cy: 242.515,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.96,
    cx: 107.482,
    cy: 118.338,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.46,
    cx: 102.867,
    cy: 114.467,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.46,
    cx: 95.3778,
    cy: 108.185,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M83.9988 98.6349L55.5457 74.7646",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.19,
    cx: 49.8574,
    cy: 69.9927,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.78,
    cx: 46.1117,
    cy: 66.8521,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.63,
    cx: 41.4969,
    cy: 62.9791,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.72,
    cx: 308.503,
    cy: 287.013,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.16,
    cx: 301.962,
    cy: 281.526,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.49,
    cx: 291.125,
    cy: 272.432,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M278.909 262.184L260.587 246.812",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 254.478,
    cy: 241.686,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.74,
    cx: 249.062,
    cy: 237.138,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.84,
    cx: 242.521,
    cy: 231.653,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.93,
    cx: 98.6681,
    cy: 130.923,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 92.8473,
    cy: 127.565,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.49,
    cx: 79.247,
    cy: 119.712,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M68.6093 113.571L42.0151 98.2188",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.72,
    cx: 36.6939,
    cy: 95.149,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.18,
    cx: 29.895,
    cy: 91.2251,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 24.0742,
    cy: 87.8638,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.88,
    cx: 325.926,
    cy: 262.13,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 323.312,
    cy: 260.62,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.66,
    cx: 321.132,
    cy: 259.362,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M307.913 251.728L261.647 225.021",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.36,
    cx: 255.036,
    cy: 221.206,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.52,
    cx: 253.946,
    cy: 220.579,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.88,
    cx: 251.332,
    cy: 219.066,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.46,
    cx: 92.1735,
    cy: 144.848,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 89.4896,
    cy: 143.869,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.97,
    cx: 78.6452,
    cy: 139.924,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M66.7852 135.608L25.2732 120.502",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 19.3432,
    cy: 118.345,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.95,
    cx: 13.9222,
    cy: 116.372,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.48,
    cx: 11.236,
    cy: 115.394,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.99,
    cx: 338.764,
    cy: 234.597,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 336.54,
    cy: 233.791,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.51,
    cx: 327.641,
    cy: 230.548,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M315.012 225.954L270.813 209.87",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.96,
    cx: 264.5,
    cy: 207.57,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.63,
    cx: 260.05,
    cy: 205.953,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.49,
    cx: 257.824,
    cy: 205.146,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.18,
    cx: 88.1977,
    cy: 159.689,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.71,
    cx: 79.4026,
    cy: 158.142,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.73,
    cx: 67.4289,
    cy: 156.03,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M55.1112 153.857L24.3135 148.429",
    stroke: "#FFB801",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.46,
    cx: 18.1535,
    cy: 147.341,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.37,
    cx: 12.1678,
    cy: 146.286,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.31,
    cx: 3.37278,
    cy: 144.737,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.82,
    cx: 346.627,
    cy: 205.255,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.49,
    cx: 342.526,
    cy: 204.533,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.56,
    cx: 333.006,
    cy: 202.856,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M320.537 200.658L276.897 192.967",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.52,
    cx: 270.662,
    cy: 191.868,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 265.901,
    cy: 191.027,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.67,
    cx: 261.8,
    cy: 190.305,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.26,
    cx: 86.8569,
    cy: 174.995,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.71,
    cx: 82.693,
    cy: 174.995,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 73.0266,
    cy: 174.995,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M60.365 174.998L16.0529 175.003",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.52,
    cx: 9.7233,
    cy: 175.002,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.74,
    cx: 4.89011,
    cy: 175.002,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.86,
    cx: 0.726141,
    cy: 175.002,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.73,
    cx: 349.274,
    cy: 174.993,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.59,
    cx: 340.263,
    cy: 174.993,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 317.602,
    cy: 174.995,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M300.542 174.998H292.012",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.41,
    cx: 283.482,
    cy: 175,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.57,
    cx: 272.152,
    cy: 175.002,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.65,
    cx: 263.141,
    cy: 175.002,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.44,
    cx: 88.1977,
    cy: 190.298,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.41,
    cx: 86.4503,
    cy: 190.608,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.95,
    cx: 75.5849,
    cy: 192.522,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M62.5771 194.819L17.0567 202.85",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 10.5529,
    cy: 203.995,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 5.12018,
    cy: 204.955,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.44,
    cx: 3.37278,
    cy: 205.262,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.55,
    cx: 346.627,
    cy: 144.73,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.86,
    cx: 337.828,
    cy: 146.282,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.91,
    cx: 314.968,
    cy: 150.315,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M298.5 153.221L290.267 154.673",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.31,
    cx: 282.032,
    cy: 156.126,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.74,
    cx: 270.602,
    cy: 158.142,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.87,
    cx: 261.805,
    cy: 159.696,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.19,
    cx: 92.1735,
    cy: 205.139,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.59,
    cx: 87.252,
    cy: 206.93,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.95,
    cx: 76.0079,
    cy: 211.025,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M62.4516 215.961L28.5565 228.299",
    stroke: "#E478EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.31,
    cx: 21.7784,
    cy: 230.764,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.24,
    cx: 16.1552,
    cy: 232.813,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.55,
    cx: 11.236,
    cy: 234.604,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.81,
    cx: 338.764,
    cy: 115.387,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.96,
    cx: 335.627,
    cy: 116.529,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.25,
    cx: 321.258,
    cy: 121.761,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M307.98 126.595L274.787 138.68",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.88,
    cx: 268.148,
    cy: 141.095,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse143 || (_ellipse143 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.95,
    cx: 260.964,
    cy: 143.709,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse144 || (_ellipse144 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.48,
    cx: 257.827,
    cy: 144.853,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse145 || (_ellipse145 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.54,
    cx: 98.6657,
    cy: 219.064,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse146 || (_ellipse146 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.19,
    cx: 94.4251,
    cy: 221.513,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse147 || (_ellipse147 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 84.5008,
    cy: 227.244,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M71.6951 234.639L39.6798 253.123",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse148 || (_ellipse148 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 33.2782,
    cy: 256.819,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse149 || (_ellipse149 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.77,
    cx: 28.3149,
    cy: 259.687,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse150 || (_ellipse150 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.41,
    cx: 24.0742,
    cy: 262.134,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse151 || (_ellipse151 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.88,
    cx: 325.926,
    cy: 87.857,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse152 || (_ellipse152 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 322.173,
    cy: 90.024,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse153 || (_ellipse153 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.93,
    cx: 311.294,
    cy: 96.3062,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M298.602 103.635L266.873 121.956",
    stroke: "#FFB801",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse154 || (_ellipse154 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.66,
    cx: 260.527,
    cy: 125.621,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse155 || (_ellipse155 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.33,
    cx: 255.085,
    cy: 128.761,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse156 || (_ellipse156 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.58,
    cx: 251.334,
    cy: 130.928,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse157 || (_ellipse157 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.89,
    cx: 107.477,
    cy: 231.649,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse158 || (_ellipse158 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    cx: 105.337,
    cy: 233.444,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse159 || (_ellipse159 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.19,
    cx: 96.7069,
    cy: 240.686,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M86.9569 248.871L52.8294 277.512",
    stroke: "#FFB801",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse160 || (_ellipse160 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 47.9544,
    cy: 281.601,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse161 || (_ellipse161 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.58,
    cx: 43.6394,
    cy: 285.224,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse162 || (_ellipse162 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.88,
    cx: 41.4969,
    cy: 287.02,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse163 || (_ellipse163 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 308.501,
    cy: 62.9742,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse164 || (_ellipse164 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.23,
    cx: 303.421,
    cy: 67.2349,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse165 || (_ellipse165 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.24,
    cx: 291.917,
    cy: 76.8921,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M282.276 84.9824L258.175 105.209",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse166 || (_ellipse166 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.61,
    cx: 253.354,
    cy: 109.255,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse167 || (_ellipse167 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 247.603,
    cy: 114.08,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse168 || (_ellipse168 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 242.523,
    cy: 118.345,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse169 || (_ellipse169 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 118.342,
    cy: 242.513,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse170 || (_ellipse170 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 115.357,
    cy: 246.07,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse171 || (_ellipse171 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.37,
    cx: 107.503,
    cy: 255.433,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M98.0988 266.643L74.5927 294.658",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse172 || (_ellipse172 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.19,
    cx: 69.892,
    cy: 300.258,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse173 || (_ellipse173 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 65.9626,
    cy: 304.941,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse174 || (_ellipse174 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.82,
    cx: 62.9791,
    cy: 308.499,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse175 || (_ellipse175 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.99,
    cx: 287.021,
    cy: 41.4937,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse176 || (_ellipse176 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.24,
    cx: 281.361,
    cy: 48.2378,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse177 || (_ellipse177 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.63,
    cx: 272.793,
    cy: 58.4507,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M264.995 67.7461L245.502 90.982",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse178 || (_ellipse178 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 241.603,
    cy: 95.6275,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse179 || (_ellipse179 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.39,
    cx: 237.318,
    cy: 100.734,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse180 || (_ellipse180 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.29,
    cx: 231.658,
    cy: 107.481,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse181 || (_ellipse181 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.14,
    cx: 130.927,
    cy: 251.327,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse182 || (_ellipse182 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.31,
    cx: 127.442,
    cy: 257.366,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse183 || (_ellipse183 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.67,
    cx: 119.297,
    cy: 271.472,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M111.339 285.259L99.4 305.939",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse184 || (_ellipse184 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.78,
    cx: 95.4219,
    cy: 312.833,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse185 || (_ellipse185 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.77,
    cx: 91.3485,
    cy: 319.884,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse186 || (_ellipse186 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.41,
    cx: 87.8631,
    cy: 325.923,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse187 || (_ellipse187 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.55,
    cx: 262.137,
    cy: 24.0689,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse188 || (_ellipse188 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.48,
    cx: 260.729,
    cy: 26.5064,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse189 || (_ellipse189 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    cx: 255.106,
    cy: 36.2505,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M248.741 47.2686L226.474 85.8471",
    stroke: "#FFB801",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M112.675 112.67L51.7721 51.7686",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M298.23 298.223L237.327 237.321",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M102.8 124.441L32.2442 75.041",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M317.756 274.954L247.203 225.552",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M95.1176 137.747L17.0545 101.348",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M332.946 248.648L254.885 212.249",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M89.8615 152.183L6.66544 129.893",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M343.335 220.1L260.139 197.81",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M87.1939 167.311L1.39072 159.809",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M348.609 190.185L262.809 182.682",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M87.1939 182.675L1.39072 190.187",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M348.612 159.804L262.806 167.316",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M89.8615 197.805L6.66544 220.102",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M343.335 129.89L260.139 152.187",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M95.1153 212.245L17.0568 248.649",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M332.946 101.343L254.885 137.746",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M102.797 225.552L32.2442 274.958",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M317.756 75.0381L247.203 124.447",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M112.673 237.321L51.7721 298.227",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M298.228 51.7666L237.327 112.675",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M124.442 247.197L75.0435 317.753",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M274.957 32.2412L225.56 102.802",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M137.747 254.878L101.352 332.941",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M248.648 17.0518L212.253 95.1151",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M152.186 260.133L129.898 343.334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M220.102 6.66309L197.816 89.8639",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M167.316 262.804L159.813 348.609",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M190.187 1.38574L182.684 87.1913",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.68 262.804L190.192 348.609",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M159.808 1.38574L167.32 87.1936",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.811 260.138L220.109 343.336",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M129.891 6.66309L152.191 89.8639",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M212.248 254.881L248.655 332.942",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M101.345 17.0518L137.754 95.1174",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M225.556 247.199L274.964 317.755",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M75.0365 32.2412L124.449 102.799",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse190 || (_ellipse190 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 223.293,
    cy: 91.3589,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse191 || (_ellipse191 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.54,
    cx: 220.479,
    cy: 96.229,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse192 || (_ellipse192 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.67,
    cx: 219.073,
    cy: 98.6665,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse193 || (_ellipse193 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.99,
    cx: 144.853,
    cy: 257.819,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse194 || (_ellipse194 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.98,
    cx: 143.429,
    cy: 261.729,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse195 || (_ellipse195 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.53,
    cx: 141.988,
    cy: 265.689,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M137.099 279.125L119.983 326.152",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse196 || (_ellipse196 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 117.538,
    cy: 332.871,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse197 || (_ellipse197 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.24,
    cx: 116.818,
    cy: 334.851,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse198 || (_ellipse198 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.79,
    cx: 115.396,
    cy: 338.761,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse199 || (_ellipse199 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.604,
    cy: 11.231,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse200 || (_ellipse200 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.72,
    cx: 231.911,
    cy: 18.6343,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse201 || (_ellipse201 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.22,
    cx: 229.834,
    cy: 24.3394,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M224.596 38.7324L211.5 74.7225",
    stroke: "#DBFF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse202 || (_ellipse202 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.78,
    cx: 208.879,
    cy: 81.9185,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse203 || (_ellipse203 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 207.843,
    cy: 84.772,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse204 || (_ellipse204 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.36,
    cx: 205.147,
    cy: 92.1753,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse205 || (_ellipse205 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 159.692,
    cy: 261.799,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse206 || (_ellipse206 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.71,
    cx: 158.544,
    cy: 268.312,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse207 || (_ellipse207 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.76,
    cx: 156.118,
    cy: 282.073,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M153.864 294.863L148.227 326.836",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse208 || (_ellipse208 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.77,
    cx: 147.1,
    cy: 333.228,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse209 || (_ellipse209 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.47,
    cx: 145.887,
    cy: 340.112,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse210 || (_ellipse210 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 144.739,
    cy: 346.625,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse211 || (_ellipse211 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 205.261,
    cy: 3.36675,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse212 || (_ellipse212 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.65,
    cx: 204.143,
    cy: 9.71343,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse213 || (_ellipse213 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 201.669,
    cy: 23.7544,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M199.417 36.5244L193.789 68.4459",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse214 || (_ellipse214 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    cx: 192.664,
    cy: 74.8326,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse215 || (_ellipse215 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.23,
    cx: 191.426,
    cy: 81.8531,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _ellipse216 || (_ellipse216 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 190.308,
    cy: 88.1988,
    rx: 0.726141,
    ry: 0.726122,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.575,
    cy: 174.577,
    r: 143.366,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_38_2824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.55 247.724C217.025 247.724 250.647 214.103 250.647 172.628C250.647 131.153 217.025 97.5312 175.55 97.5312C134.076 97.5312 100.454 131.153 100.454 172.628C100.454 214.103 134.076 247.724 175.55 247.724Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M175.55 229.191C206.791 229.191 232.117 203.647 232.117 172.137C232.117 140.627 206.791 115.083 175.55 115.083C144.31 115.083 118.984 140.627 118.984 172.137C118.984 203.647 144.31 229.191 175.55 229.191Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M173.871 259.547C226.719 259.547 269.56 216.728 269.56 163.91C269.56 111.091 226.719 68.2725 173.871 68.2725C121.023 68.2725 78.1816 111.091 78.1816 163.91C78.1816 216.728 121.023 259.547 173.871 259.547Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M184.177 269.928C237.025 269.928 279.867 227.11 279.867 174.291C279.867 121.472 237.025 78.6543 184.177 78.6543C131.329 78.6543 88.4877 121.472 88.4877 174.291C88.4877 227.11 131.329 269.928 184.177 269.928Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_38_2824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.871 275.855C226.719 275.855 269.56 233.037 269.56 180.218C269.56 127.399 226.719 84.5811 173.871 84.5811C121.023 84.5811 78.1816 127.399 78.1816 180.218C78.1816 233.037 121.023 275.855 173.871 275.855Z",
    stroke: "white",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M165.91 267.071C218.757 267.071 261.599 224.253 261.599 171.434C261.599 118.615 218.757 75.7969 165.91 75.7969C113.062 75.7969 70.2202 118.615 70.2202 171.434C70.2202 224.253 113.062 267.071 165.91 267.071Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M173.871 275.855C226.719 275.855 269.561 233.037 269.561 180.218C269.561 127.399 226.719 84.5811 173.871 84.5811C121.023 84.5811 78.1817 127.399 78.1817 180.218C78.1817 233.037 121.023 275.855 173.871 275.855Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M171.221 138.492L160.594 173.872L152.226 176.699L150.193 182.98L159.124 180.286L151.663 205.787H196.315L199.932 193.655L169.525 194.103L174.383 176.323L183.203 173.545L184.673 167.702L176.535 169.725L185.577 138.492H171.221Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_38_2824",
    x: 50.4538,
    y: 47.5312,
    width: 250.193,
    height: 250.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_38_2824"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_38_2824",
    x: 69.1816,
    y: 75.5811,
    width: 209.379,
    height: 209.274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_38_2824"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlitecoinLogo);
export default __webpack_public_path__ + "static/media/wlitecoin-logo.1802b847367c133135724ab777f80dd5.svg";
export { ForwardRef as ReactComponent };